
import { Skeleton } from '@/components/ui/skeleton';
import { EmailDetailHeader } from './EmailDetailHeader';

interface EmailDetailSkeletonProps {
  folder: string | undefined;
}

export const EmailDetailSkeleton = ({ folder }: EmailDetailSkeletonProps) => {
  return (
    <div className="flex flex-col h-full bg-background">
      <EmailDetailHeader folder={folder} />
      
      <div className="flex flex-col h-full">
        {/* Email Header with Actions */}
        <div className="border-b p-4 bg-card">
          <div className="flex items-center justify-between mb-4">
            <Skeleton className="h-8 w-20" />
            
            <div className="flex items-center gap-2">
              <Skeleton className="h-8 w-16" />
              <Skeleton className="h-8 w-20" />
              <Skeleton className="h-8 w-16" />
              <Skeleton className="h-8 w-8" />
            </div>
          </div>

          {/* Email Metadata */}
          <div className="space-y-3">
            <Skeleton className="h-6 w-3/4" />
            
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="flex items-center gap-2">
                  <Skeleton className="w-8 h-8 rounded-full" />
                  <div>
                    <Skeleton className="h-4 w-32 mb-1" />
                    <Skeleton className="h-3 w-48" />
                  </div>
                </div>
              </div>
              
              <Skeleton className="h-4 w-24" />
            </div>

            {/* Recipients */}
            <div className="space-y-1">
              <Skeleton className="h-4 w-64" />
              <Skeleton className="h-4 w-48" />
            </div>

            {/* Status Badges */}
            <div className="flex items-center gap-2">
              <Skeleton className="h-5 w-16" />
              <Skeleton className="h-5 w-24" />
            </div>
          </div>
        </div>

        {/* Email Body */}
        <div className="flex-1 p-6 overflow-auto bg-background">
          <div className="space-y-4">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-5/6" />
            <Skeleton className="h-4 w-4/5" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
            <div className="mt-6">
              <Skeleton className="h-4 w-2/3" />
              <Skeleton className="h-4 w-1/2 mt-2" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
